<template>
    <div class="user_control bg-white dark:bg-neutral-900 md2:bg-transparent md2:h-full md2:block overflow-hidden md2:overflow-visible fixed top-[70px] sm:top-20 md2:top-0 right-0 w-full md2:relative grow basis-0 transition-all duration-300 md2:transition-none min-w-max dark:text-white"
        :class="[open ? '!h-[calc(100vh-70px)] sm:!h-[calc(100vh-80px)] md2:!h-auto' : 'h-[0vh]', collapsedMenu ? 'grow-0': '']">
        <ul ref="navmenu" class="h-full text-lg divide-y dark:divide-neutral-800 md2:divide-y-0 md2:text-sm flex flex-col w-full md2:bg-none md2:flex-row md2:justify-end min-w-max relative
            min-h-[calc(100vh-70px)] sm:min-h-[calc(100vh-80px)] md2:min-h-0">
            <ul class="flex flex-col md2:flex-row divide-y dark:divide-neutral-800 md2:divide-y-0" :class="[collapsedMenu ? 'md2:bg-white md2:dark:bg-neutral-900 md2:absolute md2:p-4 md2:rounded-lg md2:bottom-0 md2:-left-[250px] md2:w-[250px] md2:flex-col md2:shadow-lg md2:translate-y-[calc(100%-5px)] md2:block':'md2:!flex', collapsedMenu && open ? 'md2:border': 'md2:hidden']">
                <li v-for="item in JSON.parse($attrs.menuitems)" class="max-h-20 h-20 md2:h-full ">
                    <a class="h-full block flex items-center justify-center px-4 cursor-pointer hover:scale-95 hover:underline transition duration-300 active:!scale-75 ref_navbar_item dark:text-white"
                        :class="[collapsedMenu && open ? 'md2:py-3' : '']"
                        :href="$homeUrl + item.url">{{ $t(item.name) }}
                    </a>
                </li>
            </ul>
            <li class="h-full max-h-20">
                <a class="h-full px-4 block flex items-center text-white cursor-pointer justify-center hover:scale-95 transition duration-300  group active:!scale-75"
                    :href="$homeUrl + '/accomodations'">
                    <span class="block bg-primary px-5 py-2 rounded-full group-active:bg-primary-dark">
                        {{ $t('Book now') }}!
                    </span>
                </a>
            </li>

            <li class="h-full max-h-20">
                <app_modal>
                    <template slot="modal_content">
                        <div class="bg-white dark:bg-neutral-800 rounded-md shadow-xl p-8 animate-in fade-in zoom-in w-full max-w-lg">
                            <div class="flex flex-col justify-between justify-items-center">
                                <a v-for="item in $attrs.locales" :href="item.url"
                                    class="hover:scale-110 p-2 hover:bg-gray-100 dark:hover:bg-neutral-600 dark:text-white rounded-full py-1 px-2 transition duration-300 cursor-pointer flex justify-start items-center">
                                    <span v-if="item.locale != 'en'"><country-flag class="!m-0" :country='item.locale' size='normal'  loading="lazy"
                                            :rounded="true" /></span>
                                    <span v-else><country-flag class="!m-0" country='gb' size='normal' loading="lazy"
                                            :rounded="true" /></span>
                                    <span v-if="item.locale != 'en'" class="ml-2">{{ $t('lang.' + item.locale) }}</span>
                                    <span v-else class="ml-2">{{ $t('lang.en') }}</span>
                                </a>
                            </div>
                        </div>
                    </template>
                    

                    <template slot="modal_button">
                        <button aria-label="Switch language"
                            class="h-full w-full justify-center relative flex items-center pr-4 focus:outline-none font-semibold cursor-pointer hover:scale-95 hover:underline transition duration-300">
                            <span v-if="$attrs.currentlocale != 'en'"><country-flag class="!m-0" loading="lazy"
                                    :country='$attrs.currentlocale' size='normal' :rounded="true" /></span>
                            <span v-else><country-flag class="!m-0" country='gb' size='normal' :rounded="true"  loading="lazy"/></span>

                            <div class="md2:hidden">
                                <span v-if="$attrs.currentlocale != 'en'" class="ml-2 mt-2 font-normal">
                                    {{ $t('lang.' + $attrs.currentlocale) }}</span>
                                <span v-else class="ml-2 mt-2 font-normal">{{ $t('lang.en') }}</span>
                            </div>
                        </button>
                    </template>
                </app_modal>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            open: false,
            collapsedMenu: false,
            menuWidth: 0,
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        onResize() {
            this.open = false
            $("body").removeClass("scroll_lock")
            if (window.innerWidth - this.menuWidth - 250 < 545) {
                this.collapsedMenu = true;
                this.$root.$emit("collapsedMenu", true);
            } else {
                this.collapsedMenu = false
                this.$root.$emit("collapsedMenu", false);
            }
        },
    },
    mounted() {
        this.$nextTick(() => {
            var totalWidth = 0;
            var items = this.$refs.navmenu.querySelectorAll('.ref_navbar_item');
            items.forEach((element) => {
                totalWidth += element.textContent.trim().length * 11 + 30;
            });
            this.menuWidth = totalWidth;
            window.addEventListener('resize', this.onResize);
            this.onResize();
        })
        this.$root.$on("showMenu", (msg) => {
            this.open = msg;
        });
    }
}
</script>

<style>
.slide-enter-active {
    transition: all .3s ease;
}

.slide-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-enter,
.slide-leave-to {
    transform: translateX(10px);
    opacity: 0;
}
</style>